import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllExpenseSlice = createSlice({
    name: "getAllExpense",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllExpenseSlice_actions = getAllExpenseSlice.actions;
export var fetchData = _getAllExpenseSlice_actions.fetchData, fetchDataSuccess = _getAllExpenseSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllExpenseSlice_actions.fetchDataFailure, resetState = _getAllExpenseSlice_actions.resetState;
export default getAllExpenseSlice.reducer;
